import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/backend/axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imageSettings: {},
    currentAnosafra: {},
    notifications: {},
    notificationCounter: 0,
    sidebarMinimized: true,
    notificationAssociableId: null,
    notificationAssociableType: null,
  },
  mutations: {
    SetImageSettings(state, settings) {
      state.imageSettings = settings
    },
    setCurrentAnosafra(state, anosafra) {
      state.currentAnosafra = anosafra
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    setNotificationCounter(state, length) {
      state.notificationCounter = length
    },
    setSidebarMinimized(state, value) {
      state.sidebarMinimized = value
    },
    setTriggerNotificationAction(state, value) {
      state.notificationAssociableId = value
    },
    setTriggerNotificationClassAction(state, value) {
      state.notificationAssociableType = value
    }
  },
  actions: {
    async fetchImageSettings(context) {
      const response = await axios.get("/api/v1/admin/settings/setting_images")
      context.commit("SetImageSettings", response.data);
    },
    async getCurrentAnosafra(context) {
      if (!(context.state.currentAnosafra && Object.keys(context.state.currentAnosafra).length)){
        const response = await axios.get(`/api/v1/anosafras/0?on_date=${new Date}`)
        context.commit('setCurrentAnosafra', response.data)
      }
    },
    async getNotificationsCounter(context) {
      const response = await axios.get(`/api/v1/count_unread_notifications`)
      context.commit('setNotificationCounter', response.data.count)
    },
    async getNotifications(context) {
      const response = await axios.get(`/api/v1/commercial_notifications.json`, { params: { q: { 'old_not_read': true } }})
      context.commit('setNotifications', response.data.commercial_notifications)
    },
    triggerNotificationAction({ commit }, associableId) {
      commit('setTriggerNotificationAction', associableId);
    },
    triggerNotificationClassAction({ commit }, associableType) {
      commit('setTriggerNotificationClassAction', associableType);
    },
    resetNotificationAction({ commit }) {
      commit('setTriggerNotificationAction', null);
    },
    resetNotificationClassAction({ commit }) {
      commit('setTriggerNotificationClassAction', null);
    }
  },
  getters: {
    getImageSettings: (state) => state.imageSettings,
  },
})
